<script>
import { NodeMixin } from '@/helpers/node-mixin';

export default {
  name: 'EmptyNode',
  mixins: [NodeMixin],
  emits: ['click'],
};
</script>
